import { render, staticRenderFns } from "./XUpload.vue?vue&type=template&id=28c1681e&"
import script from "./XUpload.vue?vue&type=script&lang=js&"
export * from "./XUpload.vue?vue&type=script&lang=js&"
import style0 from "./XUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports